import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import AddressApi from '../generated/api/Address';

export default (service: Servicelayer) => ({
  ...AddressApi(service),

  // Add custom calls here

});
